import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as InventoryModels from '../../models/inventory/inventory';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { saveAs } from 'file-saver';
import * as InventoryActions from './inventory.action';
import { InventoryService } from './inventory.service';

import { SaveState } from '../../models/commonModels';
import * as Models from '../../models/commonModels';


export interface InventoryStateModel {
  Inventory: Models.Response<InventoryModels.InventoryModel>;
  InventoryCurrent: Models.Response<InventoryModels.InventoryModel>;
  InventoryClosest: Models.Response<InventoryModels.InventoryModel>;
  InventoryList: Models.ResponseList<InventoryModels.InventoryModel>;
  Search: InventoryModels.InventorySearchModel;
  InventoriesDeposite: Models.ResponseList<InventoryModels.InventoryDepositeModel>;
  InventoryDepositeChanges: Models.Response<InventoryModels.InventoryDepositeChanges>;
  InventoryGarage: Models.Response<InventoryModels.InventoryGarageModel>;
  ProcessingChargeForExtraSeason: number;
  }

@State<InventoryStateModel>({
  name: 'inventoryState',
  defaults: {
    Inventory: null,
    InventoryList: null,
    InventoryCurrent: null,
    InventoryClosest: null,
    Search: new InventoryModels.InventorySearchModel(),
    InventoriesDeposite: null,
    InventoryDepositeChanges: null,
    InventoryGarage: null,
    ProcessingChargeForExtraSeason: null
  }
})

@Injectable()

  export class InventoryState {

    constructor(
      private inventoryService: InventoryService,
      private bannerService: BannerService,
      private helperService: HelperService
  ) { }


  @Selector()
  static Inventory(state: InventoryStateModel) {
    return state.Inventory;
  }

  @Selector()
  static InventoryCurrent(state: InventoryStateModel) {
    return state.InventoryCurrent;
  }

  @Selector()
  static InventoryClosest(state: InventoryStateModel) {
    return state.InventoryClosest;
  }

  @Selector()
  static InventoryList(state: InventoryStateModel) {
    return state.InventoryList;
  }

  @Selector()
  static Search(state: InventoryStateModel) {
    return state.Search;
  }

  @Selector()
  static InventoriesDeposite(state: InventoryStateModel) {
    return state.InventoriesDeposite;
  }

  @Selector()
  static InventoryDepositeChanges(state: InventoryStateModel) {
    return state.InventoryDepositeChanges;
  }

  @Selector()
  static InventoryGarage(state: InventoryStateModel) {
    return state.InventoryGarage;
  }

  @Selector()
  static ProcessingChargeForExtraSeason(state: InventoryStateModel) {
    return state.ProcessingChargeForExtraSeason;
  }

  @Action(InventoryActions.GetList)
  GetList(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.GetList
  ) {

    let errorMessage = 'Błąd pobierania listy inwentaryzacji';

    context.setState(
      patch({
        InventoryList: null
      })
    );

    this.inventoryService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            InventoryList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('InventoryActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(InventoryActions.Set)
  SetInventory(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.Set
  ) {

    let errorMessage = 'Błąd zapisu inwentaryzacji.';

    this.inventoryService.set(action.Inventory).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zmainy inwentaryzacji zapisane.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Inventory: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.SetInventory', error);

        this.bannerService.error(errorMessage);
      },
        () => { });
  }

  @Action(InventoryActions.SetSearch)
  SetSearch(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new InventoryActions.GetList(action.Search));
  }

  @Action(InventoryActions.SetListPage)
  SetListPage(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new InventoryActions.GetList(action.Search));
  }

  @Action(InventoryActions.ResetSearch)
  ResetSearch(
    context: StateContext<InventoryStateModel>
  ) {

    const state = context.getState();

    let search = new InventoryModels.InventorySearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new InventoryActions.GetList(search));
  }

  @Action(InventoryActions.Get)
  Get(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów inwentaryzacji.';

    this.inventoryService.get(action.Id).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Inventory: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.GetCurrent)
  GetCurrent(
    context: StateContext<InventoryStateModel>
  ) {
    const errorMessage = 'Błąd odczytu bieżącej inwentaryzacji.';

    this.inventoryService.getCurrent().subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              InventoryCurrent: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.GetCurrent', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.GetClosest)
  GetClosest(
    context: StateContext<InventoryStateModel>
  ) {
    const errorMessage = 'Błąd odczytu informacji o nadchodzących inwentaryzacjach.';

    this.inventoryService.getClosest().subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              InventoryClosest: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.GetClosest', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.Delete)
  Delete(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.Delete
  ) {

    let errorMessage = 'Błąd usunięcia inwentaryzacji.';

    this.inventoryService.delete(action.Inventory).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Inwentaryzacja usunięta.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Inventory: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.Delete', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.SetManual)
  SetManual(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.SetManual
  ) {

    let errorMessage = 'Błąd przesyłania dokumentu.';

    this.inventoryService.setManual(action.Inventory, action.File).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dokument zapisany.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Inventory: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.SetManual', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.GetManual)
  GetManual(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.GetManual
  ) {

    this.bannerService.info('Rozpoczęto pobieranie instrukcji obsługi inwentaryzacji');

    this.inventoryService.getManual(action.Inventory).subscribe(
      res => {

        const file = new File([res.body], this.helperService.GetFileNameFromHttpResponse(res), { type: res.headers.get('Content-Type') });

        saveAs(file);
      },
      res => {
        this.bannerService.error(`Błąd pobierania pliku.`);
      },
      () => {
        this.helperService.consoleLog('InventoryActions.GetManual');
      }
    );
  }

  @Action(InventoryActions.UpladSummary)
  UpladSummary(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.SetManual
  ) {

    let errorMessage = 'Błąd przsyłania dokumentu.';

    this.inventoryService.upladSummary(action.File).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dokument zapisany.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            InventoryCurrent: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.UpladSummary', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.GetDepositeInventories)
  GetDepositeInventories(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.GetDepositeInventories
  ) {

    let errorMessage = 'Błąd pobierania listy inwentaryzacji depozytu';

    this.inventoryService.getDepositeInventories(action.Deposite).subscribe((ret) => {
      if (ret.Success) {

        context.setState(
          patch({
            InventoriesDeposite: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('InventoryActions.GetDepositeInventories', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(InventoryActions.GetDepositeInventoryChanges)
  GetDepositeInventoryChanges(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.GetDepositeInventoryChanges
  ) {

    let errorMessage = 'Błąd pobierania listy zmian inwentaryzacji depozytu.';

    this.inventoryService.getDepositeInventoryChanges(action.InventoryDeposite).subscribe((ret) => {
      if (ret.Success) {

        context.setState(
          patch({
            InventoryDepositeChanges: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('InventoryActions.GetDepositeInventoryChanges', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(InventoryActions.SetSummary)
  SetDownloadDocument(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.SetSummary
  ) {

    let errorMessage = 'Błąd przesyłania dokumentu.';

    this.inventoryService.setSummary(action.InventoryGarage, action.File).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Dokument zapisany.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            InventoryGarage: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.SetSummary', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(InventoryActions.ChargeForExtraSeason)
  ChargeForExtraSeason(
    context: StateContext<InventoryStateModel>,
    action: InventoryActions.ChargeForExtraSeason
  ) {

    let errorMessage = 'Błąd naliczania przedłużenia sezonowania.';

    this.inventoryService.chargeForExtraSeason(action.Request).subscribe(
      ret => {

        this.helperService.consoleLog("yyyy ?" + ret.Success);

        if (ret.Success) {
          this.bannerService.success('Zakończono naliczanie sezonowania. Utworzono ' + ret.Item + ' specyfikacji.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            ProcessingChargeForExtraSeason: Math.random()
          })
        );
      },

      (error) => {

        this.helperService.SaveException('InventoryActions.ChargeForExtraSeason', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}

